module.exports = "https://static.wmbcdn.com/uniweb/images/4be0281c339b8b8cdc2d927af41521c5.svg";